export enum ENV {
  PROD = "prod",
  GAMMA = "gamma",
  BETA = "beta",
  LOCAL = "localhost",
}

export const AMAZON_FEDERATE_PROD = "https://idp.federate.amazon.com";

export const isLocal = (): boolean => window.location.host.includes(ENV.LOCAL);
